import React, { useState, useEffect, useContext } from 'react'
import YearlySalesHeader from './YearlySalesHeader'
import YearlySalesInner from './YearlySalesInner'
import YearlySalesFooter from './YearlySalesFooter'
import { appContext } from '../../../../../../App'
import { getYearlySalesReport } from '../../../../ReportsFunctions'

export const yearlySalesContext = React.createContext()

function useYearlySalesController() {
  const app = useContext(appContext)
  const { getClientDateTime, getClientTimezone } = app
  const [year, setYear] = useState(new Date(getClientDateTime()).getFullYear())
  const [yearlySales, setYearlySales] = useState(null)

  useEffect(() => {
    const init = async () => { setYearlySales(await getYearlySalesReport(app, year)) }
    if (year.toString().length === 4) init()

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year])

  const obj = {
    getClientDateTime,
    getClientTimezone,
    year: [year, setYear],
    yearlySales: [yearlySales, setYearlySales]
  }

  return (obj)
}

function YearlySalesController() {
  const yearlySalesController = useYearlySalesController()
  return (
    <React.Fragment>
      <yearlySalesContext.Provider value={yearlySalesController}>
        <YearlySalesHeader />
        <YearlySalesInner />
        <YearlySalesFooter />
      </yearlySalesContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(YearlySalesController)